"use client"
  import __i18nConfig from '@next-translate-root/i18n'
  import AppDirI18nProvider from 'next-translate/AppDirI18nProvider'
  import { useSearchParams as __useSearchParams, useParams as __useParams } from 'next/navigation'
  import { use as __use, Suspense as __Suspense } from 'react'
  import __loadNamespaces from 'next-translate/loadNamespaces'

  ;
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HorizontalCenterDiv } from "@/common/divs";
import { HEADER_HEIGHT } from "@/utils/constants";
const FaqsPage = () => {
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        const iframe = document.getElementById("myFrame");
        if (iframe) {
            iframe.addEventListener("load", function () { });
        }
        setTimeout(() => {
            setIsReady(true);
        }, 1500);
    }, []);
    const { i18n } = useTranslation();
    return (<>
      <iframe onLoad={() => {
            setIsReady(true);
        }} title="about-us" id="myFrame" src={i18n.language == "en" ?
            "https://vee.travel/blog/en/faqs-ingles"
            : "https://vee.travel/blog/faqs"} width="100%" style={{
            display: isReady ? "block" : "none",
            height: "calc(900px + " + HEADER_HEIGHT + ")",
        }}></iframe>

      <HorizontalCenterDiv width="100%" style={{
            height: "calc(100vh - " + HEADER_HEIGHT + ")",
            display: isReady ? "none" : "flex",
        }}>
        <CircularProgress />
      </HorizontalCenterDiv>
    </>);
};
const __Next_Translate__Page__19d9c44de19__ = FaqsPage;


  export default function __Next_Translate_new__19d9c44de19__(props) {
    const searchParams = __useSearchParams()
    const params = __useParams()
    const detectedLang = params.lang ?? searchParams.get('lang')

    if (detectedLang === 'favicon.ico') return <__Next_Translate__Page__19d9c44de19__ {...props} />

    

    const lang = detectedLang ?? __i18nConfig.defaultLocale
    const config = {
      ...__i18nConfig,
      locale: lang,
      loaderName: 'client /page',
      pathname: '/[lng]/(use-auth)/faqs/',
    }

    return (
      <__Suspense fallback={null}>
        <__Next_Translate__child__19d9c44de19__ 
          {...props} 
          config={config} 
          promise={__loadNamespaces({ ...config, loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})), })}
         />
      </__Suspense>
    )
  }

  function __Next_Translate__child__19d9c44de19__({ promise, config, ...props }) {
    const { __lang, __namespaces } = __use(promise);
    const oldNamespaces = globalThis.__NEXT_TRANSLATE__?.namespaces ?? {};
    globalThis.__NEXT_TRANSLATE__ = { lang: __lang, namespaces: { ...oldNamespaces, ...__namespaces }, config };
    return <__Next_Translate__Page__19d9c44de19__ {...props} />;
  }
